<template>
  <main>
    <div class="myPost_wrapper view" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1><img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
          공지사항
        </h1>
      </div>
      <div class="div_padding"></div>

      <div class="content-in">
        <div class="content">
          <div class="notice_title">
            <h3>{{ noticeDetail.nttSj }}</h3>
          </div>
  
          <div class="notice_file_wrap"></div>
          <!-- file list -->
          <template v-if="noticeDetail.flieList">
            <div class="attached" v-for="file in noticeDetail.flieList" :key="file.fileSn">
              <a href="#" class="file-name">{{ file.orignlFileNm }}</a>
              <a :href="file.downloadUrl" download="hello">
                <img src="images/basic/icon/file-download.svg" alt="">
              </a>
            </div>
          </template>
  
          <div class="notice_content">
            <p v-html="noticeContent"></p>
          </div>
        </div>
  
        <template v-if="noticeDetail.imgViewList">
          <div class="img_view_wrap" v-for="noticeImg in noticeDetail.imgViewList" :key="noticeImg.fileSn">
            <img :src="noticeImg.viewUrl">
          </div>
        </template>
  
        <div class="content notice_regDate">
          <span>{{ noticeDetail.ntceDay }}</span>
        </div>
      </div>
      <div class="go-list" onclick="location_notice();">글목록</div>
    </div>
  </main> 
</template>

<script>
import { fetchNoticeDetail } from '@/api/notice'
export default {
  created() {
    fetchNoticeDetail({
      nttId: this.$route.query.nttId
    })
    .then(({ data }) => {
      this.noticeDetail = data.result
      this.noticeContent = this.noticeDetail.nttCn
    })
  },
  data() {
    return {
      noticeDetail: {},
      noticeContent: ''
    }
  },

}
</script>

<style scoped>
.content {
  margin:0 30px;
}

.content .notice_title {
  padding: 1px;
  color: #252D3A;
  margin-bottom: 10px;
}

.content .notice_content {
  font-size: 14px;
  color: #252D3A;
  margin-bottom: 11px;
}

.img_view_wrap img {
  width: 100%;
  height: auto;
}
.notice_regDate {
  font-size: 12px;
  color: #9EA3AB;
  margin-top: 31px;
  padding-bottom: 50px;
}

</style>